import common from './common'
// import Vue from 'vue'

export default {
  
  setReleases(state, payload) {
    state.releases = payload
  },
  setReleasesSettings(state, payload) {
    state.releasesSettings = payload
  },
  setFeatures(state, payload) {
    state.features = payload
  },
  setFeatureDetail(state, payload) {
    state.featureDetail = payload
  },
  setNewRelease(state, payload) {
    state.releases.push( payload )
  },
  setNewFeature(state, payload) {
    let release = state.releases.find(el => el.id == payload.releaseId)
    if ( release ) {
      release.features ||= []
      release.features.push(payload)
      release.count++
    }
  },
  editRelease(state, payload) {
    let result = common._returnIndexById(state.releases, payload.id)
    if (result.success) {
      state.releases[result.returned] = Object.assign(state.releases[result.returned], payload)
    }
  },
  // editFeature(state, payload) {
  //   let release = state.releases.find(el => el.id == payload.releaseId)
  //   if ( release ) {
  //     let result = common._returnIndexById(release.features, payload.id)
  //     if (result.success) {
  //       release.features[result.returned] =  payload
  //     }
  //     let feature = release.features.find(el => el.id == payload.id) 
  //     if ( feature ) {
  //       feature = Object.assign({}, payload)
  //     }
  //   }
  // },
  deleteRelease(state, payload) {
    state.releases = state.releases.filter(el => el.id != payload?.id)
  },
  deleteFeature(state, payload) {
    let release = state.releases.find(el => el.id == payload.releaseId)
    if ( release ) {
      release.features = release.features.filter(el => el.id != payload?.id)
    }
  },
}